/**
 * 过滤数据，根据参数控制输出结果的两种等级：
 * - 完全输出必填字段的数组结果
 * - 输出字段如果值为空或未定义，则过滤掉
 * @template T - 数据的类型
 * @param {T} data - 原始数据
 * @param {Array<keyof T>} requiredFields - 必填字段的数组
 * @param {number} filterOptionalWithValue - 是否过滤非必填字段值为空或未定义的情况，1: 过滤，2: 完全输出
 * @returns {T} - 过滤后的数据
 */
export function filterDataByRequiredFields<T extends Record<string, any>>(
  data: T,
  filterOptionalWithValue = 2,
  requiredFields?: (keyof T)[]
): T {
  if (filterOptionalWithValue === 1 && !requiredFields) {
    throw new Error('When filterOptionalWithValue is 1, requiredFields must be provided.')
  }
  if (filterOptionalWithValue === 2) {
    const filteredData: T = {} as T
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        filteredData[key as keyof T] = data[key]
      }
    })
    return filteredData
  } else {
    const filteredData: T = {} as T
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    requiredFields!.forEach((key) => {
      filteredData[key] = data[key]
    })
    return filteredData
  }
}
